'use strict';
import { createAccountApi, createLoginApi, createLoginLookupApi, accountErrorMessage } from '@dealr/api-account';
import { SESSION_HANDOFF_DELAY_MS, SIM_SWAP_WARNING, backupCodesRemaining, enrollmentState, groupMethodsByStrength, hasStrengthInfo, identityProgress, identityRequirement, isBackupCodeMethod, isPasswordStrong, loginEnrollmentRequired, loginMfaPending, methodDisplayName, methodTypeLabel, opensAccountPicker, passwordStrength, rememberedUsername, resetRequirement, samlNotConfigured, samlStartUrl, stepUpKind, stepUpMethodList, stepUpPrompt, userSettingsSurface, validateIdentityConfirmationNote, verifiedIdentityLabel, webAuthnSupported } from '@dealr/core-account';
import { createLoginMfaSession, createRecoveryInbox, createStepUpFlow, createUserRecoveryActions, handOffSession, rememberLoginUsername, writeSessionCookie } from '@dealr/presenter-account';
import { createAngularHttpTransport } from '@dealr/transport';
var core = {
  SESSION_HANDOFF_DELAY_MS: SESSION_HANDOFF_DELAY_MS,
  SIM_SWAP_WARNING: SIM_SWAP_WARNING,
  backupCodesRemaining: backupCodesRemaining,
  enrollmentState: enrollmentState,
  groupMethodsByStrength: groupMethodsByStrength,
  hasStrengthInfo: hasStrengthInfo,
  identityProgress: identityProgress,
  identityRequirement: identityRequirement,
  isBackupCodeMethod: isBackupCodeMethod,
  isPasswordStrong: isPasswordStrong,
  loginEnrollmentRequired: loginEnrollmentRequired,
  loginMfaPending: loginMfaPending,
  methodDisplayName: methodDisplayName,
  methodTypeLabel: methodTypeLabel,
  opensAccountPicker: opensAccountPicker,
  passwordStrength: passwordStrength,
  rememberedUsername: rememberedUsername,
  resetRequirement: resetRequirement,
  samlNotConfigured: samlNotConfigured,
  samlStartUrl: samlStartUrl,
  stepUpKind: stepUpKind,
  stepUpMethodList: stepUpMethodList,
  stepUpPrompt: stepUpPrompt,
  userSettingsSurface: userSettingsSurface,
  validateIdentityConfirmationNote: validateIdentityConfirmationNote,
  verifiedIdentityLabel: verifiedIdentityLabel,
  webAuthnSupported: webAuthnSupported
};
var presenter = {
  createLoginMfaSession: createLoginMfaSession,
  createRecoveryInbox: createRecoveryInbox,
  createStepUpFlow: createStepUpFlow,
  createUserRecoveryActions: createUserRecoveryActions,
  handOffSession: handOffSession,
  rememberLoginUsername: rememberLoginUsername,
  writeSessionCookie: writeSessionCookie
};
function browserWebAuthn() {
  var nav = typeof navigator !== 'undefined' ? navigator : null;
  var supported = core.webAuthnSupported({
    publicKeyCredential: typeof window !== 'undefined' ? window.PublicKeyCredential : null,
    credentials: nav && nav.credentials
  });
  if (!supported) return null;
  return {
    create: function (publicKey) {
      return nav.credentials.create({
        publicKey: publicKey
      });
    },
    get: function (publicKey) {
      return nav.credentials.get({
        publicKey: publicKey
      });
    }
  };
}
angular.module('app').factory('dealrAccount', ['$http', '$q', '$window', function ($http, $q, $window) {
  function confirmLogin(prompt) {
    var message = String(prompt.message || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    return $window.confirm(message || 'Another session is already active. Continue and sign out the other session?');
  }
  var transport = createAngularHttpTransport($http, {
    ngQ: $q
  });
  var api = createAccountApi(transport, {
    confirmLogin: confirmLogin
  });
  api.signIn = createLoginApi(transport, confirmLogin, {
    parse: 'raw'
  });
  api.loginLookup = createLoginLookupApi(transport, {
    parse: 'raw'
  });
  return {
    api: api,
    core: core,
    presenter: presenter,
    errorMessage: accountErrorMessage,
    webauthn: browserWebAuthn
  };
}]);